
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import PrivateRoute from './PrivateRouting';
import ProtectedLoginRoute from './ProtectedLoginRoute';
import { RoutesLink } from '@/utility/RouteLinks';
import Login from '@/pages/auth/Login';
import SuperAdminDashboard from '@/pages/SuperAdmin/Dashboard/SuperAdminDashboard';
import Forgot from '@/pages/auth/Forgot';
import VerifyOtp from '@/pages/auth/VerifyOtp';
import ResetPassword from '@/pages/auth/ResetPassword';
import Employees from '@/pages/SuperAdmin/Employee/Employees';
import CreateEmployee from '@/pages/SuperAdmin/Employee/CreateEmployee';
import Department from '@/pages/SuperAdmin/Department/Department';
import AddDepartment from '@/pages/SuperAdmin/Department/AddDepartment';
import Branch from '@/pages/SuperAdmin/Branch/Branch';
import AddBranch from '@/pages/SuperAdmin/Branch/AddBranch';
import Company from '@/pages/SuperAdmin/Company/Company';
import CreateCompany from '@/pages/SuperAdmin/Company/CreateCompany';
import ShiftAndTime from '@/pages/SuperAdmin/ShiftAndTime/ShifAndTime';
import AddShiftAndTime from '@/pages/SuperAdmin/ShiftAndTime/AddShiftAndTime';
import Designation from '@/pages/SuperAdmin/Designation/Designation';
import AddDesignation from '@/pages/SuperAdmin/Designation/AddDesignation';
import SsoLogin from '@/pages/auth/SsoLogin';
import Site from '@/pages/SuperAdmin/Site/Site';
import AddSite from '@/pages/SuperAdmin/Site/AddSite';
// import CampusConfig from '@/pages/SuperAdmin/Campus/CampusConfig';
import AddCampus from '@/pages/SuperAdmin/Campus/AddCampus';
import CampusConfig from '@/pages/SuperAdmin/Campus/CampusConfig';
import Application from '@/pages/SuperAdmin/Applications/Application';
import AddApplication from '@/pages/SuperAdmin/Applications/AddApplication';
import Profile from '@/pages/SuperAdmin/Profile/Profile';
import EditProfile from '@/pages/SuperAdmin/Profile/EditProfile';
import EmployeeDetail from '@/pages/SuperAdmin/Employee/EmployeeDetail';
import LeaveSetting from '@/pages/SuperAdmin/HrmsSettings/LeaveSettings/LeaveSettings';
import AddLeaveSetting from '@/pages/SuperAdmin/HrmsSettings/LeaveSettings/AddLeaveSetting';
import AddLeave from '@/pages/SuperAdmin/Leave/AddLeave';
import LeaveDetail from '@/pages/SuperAdmin/Leave/LeaveDetail';
import TeamLeave from '@/pages/SuperAdmin/Leave/TeamLeave';
import MyLeave from '@/pages/SuperAdmin/Leave/MyLeave';

interface IPrivateRoutes {
    path: string;
    route: React.ReactNode;
}

export default function CommonRouts() {

    const ProtectedLoginRoutes = [

        {
            path: RoutesLink?.authRoutes?.login,
            route: <Login />,
        },
        {
            path: RoutesLink?.authRoutes?.forgot,
            route: <Forgot />,
        },
        {
            path: RoutesLink?.authRoutes?.verifyOtp,
            route: <VerifyOtp />,
        },
        {
            path: RoutesLink?.authRoutes?.resetPassword,
            route: <ResetPassword />,
        },



    ];

    const privateRoutes: IPrivateRoutes[] = [

        {
            path: RoutesLink.superAdminDashboard,
            route: <SuperAdminDashboard />,
        },
        {
            path: RoutesLink.superAdminEmployees,
            route: <Employees />,
        },
        {
            path: `${RoutesLink.employeeDetail}/:id`,
            route: <EmployeeDetail />,
        },
        {
            path: RoutesLink.createEmployee,
            route: <CreateEmployee />,
        },
        {
            path: `${RoutesLink.editEmployee}/:id`,
            route: <CreateEmployee />,
        },
        // Profile
        {
            path: RoutesLink.profile,
            route: <Profile />,
        },
        {
            path: RoutesLink.editProfile,
            route: <EditProfile />,
        },
        {
            path: RoutesLink.superAdminDepartment,
            route: <Department />,
        },
        {
            path: RoutesLink.addDepartment,
            route: <AddDepartment />,
        },
        {
            path: `${RoutesLink.editDepartment}/:id`,
            route: <AddDepartment />,
        },
        {
            path: RoutesLink.superAdminBranch,
            route: <Branch />,
        },
        {
            path: RoutesLink.addBranch,
            route: <AddBranch />,
        },
        {
            path: `${RoutesLink.editBranch}/:id`,
            route: <AddBranch />,
        },
        {
            path: RoutesLink.company,
            route: <Company />,
        },
        {
            path: RoutesLink.createCompany,
            route: <CreateCompany />,
        },
        {
            path: `${RoutesLink.editCompany}/:id`,
            route: <CreateCompany />,
        },
        {
            path: RoutesLink.shiftAndTime,
            route: <ShiftAndTime />,
        },
        {
            path: RoutesLink.addShiftAndTime,
            route: <AddShiftAndTime />,
        },
        {
            path: `${RoutesLink.editShiftAndTime}/:id`,
            route: <AddShiftAndTime />,
        },
        //   designation
        {
            path: RoutesLink.superAdminDesignation,
            route: <Designation />,
        },
        {
            path: RoutesLink.addDesignation,
            route: <AddDesignation />,
        },
        {
            path: `${RoutesLink.editDesignation}/:id`,
            route: <AddDesignation />,
        },
        // Site
        {
            path: RoutesLink.superAdminSite,
            route: <Site />,
        },
        {
            path: RoutesLink.addSite,
            route: <AddSite />,
        },
        {
            path: `${RoutesLink.editSite}/:id`,
            route: <AddSite />,
        },
        // campus
        {
            path: RoutesLink.superAdminCampus,
            route: <CampusConfig />,
        },
        {
            path: RoutesLink.addCampus,
            route: <AddCampus />,
        },
        {
            path: `${RoutesLink.editCampus}/:id`,
            route: <AddCampus />,
        },
        // applications
        {
            path: RoutesLink.superAdminApplication,
            route: <Application />,
        },
        {
            path: RoutesLink.addApplication,
            route: <AddApplication />,
        },
        {
            path: `${RoutesLink.editApplication}/:id`,
            route: <AddApplication />,
        },
        {
            path: RoutesLink.profile,
            route: <Profile />,
        },
        {
            path: RoutesLink.editProfile,
            route: <EditProfile />,
        },
        // Leave Setting
        {
            path: RoutesLink.leaveSetting,
            route: <LeaveSetting />,
        },
        {
            path: RoutesLink.addLeaveSetting,
            route: <AddLeaveSetting />,
        },
        {
            path: `${RoutesLink.editLeaveSetting}/:id`,
            route: <AddLeaveSetting />,
        },
        // Leave
        {
            path: RoutesLink.addLeave,
            route: <AddLeave />,
        },
        {
            path: `${RoutesLink.editLeave}/:id`,
            route: <AddLeave />,
        },
        {
            path: `${RoutesLink.leaveDetail}/:id`,
            route: <LeaveDetail />,
        },
        {
            path: RoutesLink.teamLeave,
            route: <TeamLeave />,
        },
        {
            path: RoutesLink.myLeave,
            route: <MyLeave />,
        },

    ];


    const location = useLocation();

    return (
        <>
            <Routes>
                {ProtectedLoginRoutes.map((route, index) => (
                    <Route
                        key={`login-${index}`}
                        path={route.path}
                        element={<ProtectedLoginRoute element={route.route} />}
                    />
                ))}

                {/* All Private Routes — generated per role */}
                {privateRoutes.map((route, index) => (
                    <Route
                        key={`private-${index}`}
                        path={route.path}
                        element={<PrivateRoute element={route.route} />}
                    />
                ))}

                {/* Public standalone route — accessible regardless of auth state */}
                <Route path={RoutesLink.authRoutes.ssoLogin} element={<SsoLogin />} />

                {/* Global Fallback */}
                <Route path="*" element={<Navigate to={{ pathname: RoutesLink.authRoutes.login, search: location.search }} replace />} />
            </Routes>
        </>
    );
}
